import { SERVERS_PATH } from "@colossus/contracts/tenant-home";
import { attempt } from "#lib/admin/load.ts";
import { consoleClient } from "#lib/api.ts";
import { landingHref } from "#lib/dashboard.ts";
import type { ConsoleOk } from "#lib/query.ts";
import { leaveSignedOut, signOut } from "./me.ts";
import { loadWorkspace } from "./workspace.ts";

export type HeldAccounts = ConsoleOk<"/api/auth/accounts">;

export type HeldAccount = HeldAccounts["accounts"][number];

const LOGIN_PATH = "/api/auth/login";

export const addAccountHref = (origin: string): string =>
  `${LOGIN_PATH}?${new URLSearchParams({ return: origin, add: "1" }).toString()}`;

const landOnActiveAccount = async (): Promise<void> => {
  const client = consoleClient(fetch);
  const [me, workspace] = await Promise.all([
    attempt(client.call("get", "/api/auth/me")),
    loadWorkspace(client, { refresh: true }),
  ]);
  globalThis.location.assign(me.ok ? landingHref(workspace, me.data.lastTenantId) : SERVERS_PATH);
};

export const heldAccounts = async (): Promise<HeldAccounts | null> => {
  const result = await attempt(consoleClient(fetch).call("get", "/api/auth/accounts"));
  return result.ok ? result.data : null;
};

export const switchTo = async (accountId: string): Promise<boolean> => {
  const result = await attempt(
    consoleClient(fetch).call("post", "/api/auth/switch", { body: { accountId } }),
  );
  if (result.ok) await landOnActiveAccount();
  return result.ok;
};

export const signOutOf = async (
  account: Pick<HeldAccount, "accountId" | "active">,
): Promise<boolean> => {
  const result = await attempt(
    consoleClient(fetch).call("post", "/api/auth/remove", {
      body: { accountId: account.accountId },
    }),
  );
  if (!result.ok) return false;
  if (!account.active) return true;
  if (result.data.signedIn) await landOnActiveAccount();
  else leaveSignedOut();
  return true;
};

export const signOutAll = (): Promise<void> => signOut(consoleClient(fetch));
